import { PERIPHERAL } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: PERIPHERAL,
  params: null,
  view: {
    title: '创建外设',
    labelPosition: 'right',
    labelWidth: '200px',
    width: '500px',
    content: [
      {
        $id: 'name',
        $type: 'input',
        label: '外设名称',
        rules: [
          {
            notEmpty: '外设名称'
          }
        ]
      },
      {
        $id: 'type',
        $type: 'input',
        label: '类型',
        rules: [
          {
            notEmpty: '类型'
          }
        ]
      },
      {
        $id: 'interfaceType',
        $type: 'input',
        label: '接口类型',
        rules: [
          {
            notEmpty: '接口类型'
          }
        ]
      },
      {
        $id: 'manufacturer',
        $type: 'input',
        label: '制造商',
        rules: [
          {
            notEmpty: '制造商'
          }
        ]
      },
      {
        $id: 'hardwareCode',
        $type: 'input',
        label: '硬件编码',
        rules: [
          {
            notEmpty: '硬件编码'
          }
        ]
      },
      {
        $id: 'description',
        $type: 'input',
        label: '描述',
        rules: [
          {
            notEmpty: '描述'
          }
        ]
      }
      // {
      //   $id: 'specPeripheralConfigDTOList',
      //   $type: 'sky-product-os-relate',
      //   label: '支持的产品及操作系统',
      //   rules: [
      //     {
      //       // notEmpty: '支持的产品及操作系统'
      //     }
      //   ]
      // }
    ]
  }
}
